'use client';

import CtaArrowIcon from '@/components/icons/CtaArrowIcon';
import { externalCtaLinkClassName } from '@/components/elements/WebLink';

// BL-748: production opens VerifyPass in a small centered popup window
// (cdn.verifypass.com/seller/launcher.js -> verifypass_popup), not a normal
// new tab. Staging has no reason to load that third-party script just for
// this one CTA, so we replicate its window.open call/dimensions directly.
function openVerifyPassPopup(url) {
  const screenX = window.screenLeft ?? window.screenX;
  const screenY = window.screenTop ?? window.screenY;
  const width = window.innerWidth || document.documentElement.clientWidth || screen.width;
  const height = window.innerHeight || document.documentElement.clientHeight || screen.height;
  const left = width / 2 - 237.5 + screenX;
  const top = height / 2 - 347.5 + screenY;
  const popup = window.open(url, 'VerifyPass', `scrollbars=yes,width=475,height=695,top=${top},left=${left}`);
  popup?.focus();
}

export function VerifyPassCTALink({ label, link, showIcon = true, align = 'justify-center' }) {
  if (!link || !label) return null;

  return (
    <div className={`birch-cta flex ${align} md:px-0 xl:px-4 mt-6`}>
      {/* Real href keeps cmd/middle-click, context menu, and popup-blocked users working. */}
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={label + ' (opens in a new tab)'}
        onClick={(e) => {
          e.preventDefault();
          openVerifyPassPopup(link);
        }}
        className={externalCtaLinkClassName}
      >
        {label}
        {showIcon && <CtaArrowIcon />}
      </a>
    </div>
  );
}
